import { MdPrint } from 'react-icons/md';
import { useScreenInfo } from 'hooks';
import { ConsignmentDetails } from 'types';
import { Print, Text } from 'components';
import { FontSize, FontWeight, STATUSES, TEST_IDS, salesMode } from 'commons';
import { CollectReceipt } from './components';
import * as S from './styles';

interface Props {
  consignmentDetails: ConsignmentDetails;
}

export function CollectRegistration({ consignmentDetails }: Props) {
  const { isMobile } = useScreenInfo();
  const { lastRegistration, status } = consignmentDetails;
  const { receiverName, receiverCpf, carrier } = lastRegistration;
  const isShippingFromStore =
    salesMode.shipping === consignmentDetails.salesMode &&
    status !== STATUSES.MANUALLY_DELIVERED.value;

  const receiverLabel = isShippingFromStore
    ? 'Retirado pelo Transportador'
    : 'Retirado pelo Cliente';

  return (
    <S.Main>
      <Text size={FontSize.font12}>
        <strong>IMPORTANTE:</strong> Lembre-se de realizar a impressão do
        comprovante de retirada e solicitar a assinatura do mesmo. O comprovante
        é essencial para comprovar a entrega do pedido ou acionar o
        transportador em caso de extravio. Guarde-o por 30 dias.
      </Text>

      <S.Wrapper>
        <S.TextWrapper>
          <Text size={FontSize.font12} weight={FontWeight.bold}>
            {receiverLabel}:
          </Text>

          <Text size={FontSize.font12}>{receiverName}</Text>
        </S.TextWrapper>

        <S.TextWrapper>
          <Text size={FontSize.font12} weight={FontWeight.bold}>
            CPF:
          </Text>

          <Text size={FontSize.font12}>{receiverCpf}</Text>
        </S.TextWrapper>

        {isShippingFromStore && (
          <S.TextWrapper>
            <Text size={FontSize.font12} weight={FontWeight.bold}>
              Transportadora:
            </Text>

            <Text size={FontSize.font12}>{carrier}</Text>
          </S.TextWrapper>
        )}
      </S.Wrapper>

      {!isMobile && (
        <S.ButtonWrapper>
          <Print
            data-testid={TEST_IDS.PRINT_COLLECT_RECEIPT_BUTTON}
            Template={
              <CollectReceipt
                consignmentDetails={consignmentDetails}
                isShippingFromStore={isShippingFromStore}
              />
            }
          >
            <S.ButtonContent>
              <MdPrint />
              Imprimir Comprovante
            </S.ButtonContent>
          </Print>
        </S.ButtonWrapper>
      )}
    </S.Main>
  );
}
